// @ts-nocheck
import { DynamicFormService } from './dynamic-form.service';

/**
 * Interpretadores de template
 */
interface IFormTemplate {
	id: string;
	subforms: Array<ISubForm>;
}

interface ISubForm {
	id: string;
	fields?: Array<Array<ISubFormField>>;
	moduleDependency?: Array<ISubFormModuleDependency>;
	disable: boolean;
	entityKey: string;
	entityId: string;
	label: string;
	type: string;
	required?: boolean;
}
interface IFieldControlDependency {
	entityKey: string;
	msg: string;
	lockCondition: any;
}
interface ISubFormModuleDependency {
	lockConditions: Array<any>;
	fieldDependency: Array<IFieldControlDependency>;
	moduleId: string;
	defaultCondition: {
		[configuration: string]: boolean;
	};
}

interface ISubFormField {
	entityKey: string;
	entityRecoverKey?: string;
	entityColumnName?: string;
	type: string;
	required: boolean;
	label: string;
	childrenDependency?: ISubFormChildrenDependencies;
	disabled: boolean;
	auxEntity?: {
		entityUrl: string;
		tableName?: string;
		isDependent?: boolean;
		entityAttribute?: string;
		fatherKey?: string;
		entityParameter?: string;
	};
	size: number;
	helperText?: string;
	defaultValue?: string;
	isFatherDependency?: boolean;
	mask?: string;
	bibEntity?: IBibEntity;
}

interface IBibEntity {
	code?: number;
	deleted?: boolean;
	hasChild?: boolean;
	id?: string;
	label?: string;
	parentId?: string;
	filters?: IFilters;
}

interface IFilters {
	uf?: string;
	eletronicSystem?: string;
}

interface ISubFormChildrenDependencies {
	defaultCondition: IFormControlConditions;
	father: Array<ISubFormChildrenDependency>;
	conditions: Array<any>;
}

interface ISubFormChildrenDependency {
	entityKeyAuxWhere: string;
	fieldKey: string;
	module: string;
}

type IFormControlConditions = IFormControlConditionsConfiguration & {
	visible?: boolean;
};

interface IFormControlConditionsConfiguration {
	[configuration: string]: boolean;
}

/** */

/**
 * Controladores de formulário
 */
interface IFormControlStructure {
	fieldControl: IFieldControl;
	moduleControl: IModuleControl;
	fieldDependency: IFieldDependency;
	moduleDependency: IModuleDependency;
}

interface IFieldControl {
	[entityKey: string]: Field;
}

interface IModuleControl {
	[moduleId: string]: IModule;
}

interface IFieldDependency {
	[parentEntityKey: string]: {
		[entityKey: string]: {
			defaultCondition: any;
			conditions: Array<any>;
		};
	};
}

interface IModuleDependency {
	[entityKey: string]: {
		[foreignerModuleId: string]: {
			lockConditions: Array<any>;
			unlocked?: boolean;
		};
	};
}

interface IField {
	value: FieldValue;
	error: string[];
	required: boolean;
	visible?: boolean;
	valid: boolean;
	fieldKey: string;
	disabled: boolean;
	hasMask: boolean;
	bibEntity?: IBibEntity;
	initialized?: boolean;
}

interface IModule {
	hidden?: boolean;
	locked: boolean;
	unlocked?: boolean;
	id: string;
	moduleLockMessages?: Map<string, string>;
	entityKey: string;
	fields: string[];
}

interface ArrayOneEntity {
	primary: string;
	data: Array<string>;
}

export type FieldValue =
	| string
	| number
	| boolean
	| Array<string | Record<string, any>>
	| ArrayOneEntity
	| undefined
	| any;

export type ChangeInterceptorPayload = {
	value: FieldValue;
	id: string;
	changeSource: 'firstLoad' | 'userInput' | null;
};

export class FormControlStructure implements IFormControlStructure {
	formMetadata?: any;
	moduleControl: IModuleControl = {};
	moduleDependency: IModuleDependency = {};
	fieldControl: IFieldControl = {};
	fieldDependency: IFieldDependency = {};
}
export class Field implements IField {
	private _value: FieldValue;
	private _valid: boolean;
	private _shouldFireAutoSave: boolean = true;
	error: string[];
	required: boolean;
	visible?: boolean;
	fieldKey: string;
	entityRecoverKey?: string;
	disabled: boolean;
	initialized: boolean;
	hasMask: boolean;
	parents: Array<string> = [];
	bibEntity?: IBibEntity;
	locked?: boolean;
	unlocked?: boolean;
	msg?: string;
	fieldLockMessages?: Map<string, string>;
	disabledDateRules?: any;

	constructor(
		private dynamicFormService: DynamicFormService,
		fieldKey: string,
		required = false,
		disabled = false,
		hasMask = false,
		entityRecoverKey?: string,
		bibEntity?: IBibEntity,
		locked = false,
		unlocked?: boolean,
		msg?: string,
		fieldLockMessages?: Map<string, string>,
		disabledDateRules?: any,
	) {
		this.fieldKey = fieldKey;
		this.entityRecoverKey = entityRecoverKey;
		this.required = required;
		this.hasMask = hasMask;
		this.error = [];
		this.visible = true;
		this._valid = hasMask ? false : true;
		this.disabled = disabled;
		this.initialized = false;
		this.bibEntity = bibEntity;
		this.locked = locked;
		this.unlocked = unlocked;
		this.msg = msg;
		this.fieldLockMessages = fieldLockMessages;
		this.disabledDateRules = disabledDateRules;
	}

	public set valid(value: boolean) {
		this._valid = value;
	}
	public get valid() {
		return this._valid;
	}
	public get value(): FieldValue {
		return this._value;
	}
	public set value(value: FieldValue) {
		if (this._value === value) return;
		this._value = value;

		if (!this.initialized) {
			this.initialized = true;
		}
		if (!this.disabled) {
			if (this.initialized && this.shouldFireAutoSave) {
				this.dynamicFormService.setTimeOutToSaveData(this.fieldKey, value);
			} else {
				this.valid = true;
			}

			this.dynamicFormService.fieldDependencyInterceptor.emit(this);
			this.dynamicFormService.moduleDependencyInterceptor.emit(this);
		}
	}
	public get shouldFireAutoSave(): boolean {
		return this._shouldFireAutoSave;
	}
	public set shouldFireAutoSave(value: boolean) {
		this._shouldFireAutoSave = value;
	}
}

export class Module implements IModule {
	constructor(id: string, entiyKey: string, locked = false) {
		this.id = id;
		this.locked = locked;
		this.entityKey = entiyKey;
		this.fields = [];
	}
	hidden?: boolean;
	fields: string[];
	unlocked: true = true;
	locked: boolean;
	id: string;
	entityKey: string;
	moduleLockMessages?: Map<string, string> | undefined;
}

export { IFieldControl, ISubForm };

